import React from "react";
import "./WelcomeCard.css";
import DisplayTherapist from "./DisplayTherapist";

const WelcomeCard = ({ therapist }) => {
  return (
    <div className="welcomeCardContainer">
      <div className="welcomeCard">
        <div className="welcomeCardTitle">
          Welcome to Teresa DeAnn Langley, LPC
        </div>
        <div className="welcomeCardContent"></div>
        <DisplayTherapist therapist={therapist} />
      </div>
    </div>
  );
};

export default WelcomeCard;
